import React, { useState, FC, useEffect, Dispatch, SetStateAction } from 'react'
import Button from 'ps-components/Button/Button';
import LoadingIndicator from 'ps-components/LoadingIndicator/LoadingIndicator';
import { hideSlideout } from 'ps-components/Slideout/SlideoutReducer';
import { Input } from 'ps-design';
import { Radio, RadioGroup } from '../../../ps-aspect-design'
import { useDispatch, useSelector } from 'react-redux';
import { useToast } from 'ps-shared-ui/v4/Toast';
import { ParticipationReport, Survey } from './types';
import { useMutation } from 'react-query';
import { TOAST_ERROR_OPTIONS, TOAST_SUCCESS_OPTIONS } from '../../../constants';
import axios from 'ps-components/lib/apiClient';
import { IAppState } from '../../../lib/types';
import { useQueryParams } from '../../../hooks/util';
import { ConfirmationModal } from './ConfirmationModal';

type Props = {
    selectedReport: ParticipationReport | undefined
    setSelectedReport: Dispatch<SetStateAction<ParticipationReport | undefined>>
    setSelectedSurvey: Dispatch<SetStateAction<Survey | undefined>>
}

export const ParticipationReportSlideoutFooter: FC<Props> = ({ selectedReport, setSelectedReport, setSelectedSurvey }) => {
    const defaultReportName = selectedReport?.name + ' (COPY)'
    const [isOverrideReportName, setIsOverrideReportName] = useState<'yes' | 'no'>('no')
    const [overrideReportName, setOverrideReportName] = useState<string | undefined>(defaultReportName)
    const { masterAccountId } = useSelector((state: IAppState) => state.session)
    const dispatch = useDispatch()
    const toast = useToast()
    const query = useQueryParams()
    const surveySourceId = query.get('pub_survey_source_id')
    const [confimationModalOpen, setConfimationModalOpen] = useState<boolean>(false)

    const migrateReport = async () => {
        try {
            const response = await axios.apiPost(`/cms/api/accounts/${masterAccountId}/migrateParticipationReport`, { newSurveySourceId: surveySourceId, reportPk: selectedReport?.pk, newReportName: overrideReportName })
            if (response.data.success) {
                toast('Participation report successfully copied.', TOAST_SUCCESS_OPTIONS)
                dispatch(hideSlideout())
                const iframe = document.getElementById('acs-iframe') as HTMLIFrameElement
                if (iframe.contentWindow !== null) iframe.contentWindow.location.reload()
            } else {
                toast('Failed to copy over participation report.', TOAST_ERROR_OPTIONS)
            }
        } catch (err) {
            console.error(err)
            toast('Failed to copy over participation report.', TOAST_ERROR_OPTIONS)
        }
    }

    const { mutate, isLoading } = useMutation(migrateReport, { retry: 1 })

    const handleSubmit = () => {
        mutate()
        setConfimationModalOpen(false)
    }

    const handleClose = () => {
        dispatch(hideSlideout())
        setSelectedSurvey(undefined)
        setSelectedReport(undefined)
    }

    useEffect(() => {
        if (selectedReport) setOverrideReportName(defaultReportName)
    }, [selectedReport])

    return (
        <div>
            <ConfirmationModal open={confimationModalOpen} setIsOpen={setConfimationModalOpen} onSubmit={handleSubmit} />
            <LoadingIndicator loading={isLoading} />
            {selectedReport &&
                <div className='pcenter-slideout__footer_container'>
                    <p className='pcenter-slideout__footer_rename-text'>Would you like to rename report?</p>
                    <RadioGroup name='rename-report-radio-group'>
                        <div className='pcenter-slideout__footer_cb_container'>
                            <Radio
                                label="Yes"
                                value={'yes'}
                                checked={isOverrideReportName === 'yes'}
                                onChange={() => setIsOverrideReportName('yes')}
                            />
                            <Radio
                                label="No"
                                value={'no'}
                                checked={isOverrideReportName === 'no'}
                                onChange={() => setIsOverrideReportName('no')}
                            />
                        </div>
                    </RadioGroup>
                    <div className='pcenter-slideout__footer_rename-input'>
                        <Input
                            disabled={isOverrideReportName === 'no'}
                            value={isOverrideReportName === 'no' ? defaultReportName : overrideReportName }
                            onChange={(_: undefined, val: string) => setOverrideReportName(val)}
                        />
                    </div>
                </div>
            }
            <hr />
            <div className='pcenter-slideout__footer_buttons'>
                <Button className="pxl-btn pxl-margin-small" onClick={handleClose}>Cancel</Button>
                <Button className="pxl-btn pxl-btn-primary pxl-margin-small" disabled={!selectedReport || isLoading} onClick={() => setConfimationModalOpen(true)}>Copy Over Report</Button>
            </div>
        </div>
    )
}